import { StyledRadioGroup } from "../../../DriverPopUp/common/RadioGroup";
import FormSectionHeader from "../common/FormSectionHeader";
import { withStyles } from "@material-ui/core";
import styles from "./styles";
import { TextFieldWithLabel } from "../components/TextField";
import appConstant from "../../../../../../../appConstants";
import { DateTimeEditorWithLabel } from "../components/DateTimeEditor";
import {
  convertDateTimeToTimeString,
  isTimeValid,
} from "../../../../../../dataGrid/gridUtilities";
import { getFieldError, getDefaultEditReasonErrorInfo } from "./utils";
import { EDIT_REASON_OPTIONS } from "../constants";
import { memo } from "react";
const EditReasonForm = ({
  classes,
  editReasonInfo,
  editReasonErrorInfo,
  updateFormData,
  isDateTimeUpdated,
}) => {
  const handleTimeChange = (value) => {
    if (!value || isTimeValid(convertDateTimeToTimeString(value))) {
      handleChange("callTime")(value);
    }
  };

  const handleChange = (name) => (value) => {
    const editReasonData = {
      ...editReasonInfo,
      [name]: value,
    };
    const editReasonErrorData =
      name === "editReasonCode"
        ? getDefaultEditReasonErrorInfo()
        : {
            ...editReasonErrorInfo,
            [name]: getFieldError({
              fieldName: name,
              value,
              isDateTimeUpdated,
              editReasonInfo,
            }),
          };
    updateFormData(
      "editReasonInfo",
      editReasonData,
      editReasonErrorData,
    );
  };
  return (
    <>
      <FormSectionHeader label="Edit Reason Info" />
      <div className={classes.formContainer} id="editReasonInfo">
        <StyledRadioGroup
          onChange={handleChange("editReasonCode")}
          options={EDIT_REASON_OPTIONS}
          value={editReasonInfo.editReasonCode}
          error={Boolean(editReasonErrorInfo.editReasonCode)}
          helperText={editReasonErrorInfo.editReasonCode}
        />
        <div className={classes.inputFieldWrapper}>
          <TextFieldWithLabel
            label="Contact Name :"
            id="contactName"
            labelClass={classes.label}
            handleChange={handleChange("contactName")}
            error={editReasonErrorInfo.contactName}
            value={editReasonInfo.contactName}
            inputClass={classes.contactName}
          />
          <DateTimeEditorWithLabel
            label="Call Time"
            id="callTime"
            dateType={appConstant.DATETYPES.TIME}
            labelClass={classes.label}
            inputClass={classes.timeInput}
            value={convertDateTimeToTimeString(editReasonInfo.callTime)}
            onChange={handleTimeChange}
            disableFocusInput
            enablePickerPortal
            errorText={editReasonErrorInfo.callTime ?? ""}
          />
          <div className={classes.commentsWrapper}>
            <TextFieldWithLabel
              label="Comments :"
              id="comments"
              labelClass={classes.commentsLabel}
              handleChange={handleChange("comments")}
              error={editReasonErrorInfo.comments}
              value={editReasonInfo.comments}
              inputClass={classes.comments}
              multiline
              rows={3}
            />
          </div>
        </div>
      </div>
    </>
  );
};

export default withStyles(styles)(memo(EditReasonForm));
